import { AnimatePresence, motion } from 'motion/react';

import { AGENT_DURATIONS, AGENT_EASING } from '../../../Helpers/Agents/animations';

interface ThinkingPhaseListProps {
  phases: string[];
  isLive: boolean;
}

const ThinkingPhaseList = ({ phases, isLive }: ThinkingPhaseListProps) => {
  if (phases.length === 0) return null;

  return (
    <div className="overflow-hidden">
      <AnimatePresence initial={false}>
        {phases.map((phase, index) => {
          const isActive = isLive && index === phases.length - 1;
          return (
            <motion.div
              // eslint-disable-next-line react/no-array-index-key
              key={`${index}-${phase}`}
              initial={{ opacity: 0, y: -4 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: AGENT_DURATIONS.slow, ease: AGENT_EASING.outExpo }}
              className={`flex items-start gap-2.5 border-b border-[#10182812] px-3.5 py-2.5 text-[12.5px] last:border-b-0 ${
                isActive ? 'text-gray-900' : 'text-gray-500'
              }`}>
              <span aria-hidden className="mt-px inline-flex h-3.5 w-3.5 flex-shrink-0 items-center justify-center">
                <span
                  className="inline-block h-[7px] w-[7px] rounded-full"
                  style={{ backgroundColor: isActive ? '#7c6cf6' : '#22c55e' }}
                />
              </span>
              <div className="min-w-0 flex-1">
                <div className="font-medium leading-snug">{phase}</div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default ThinkingPhaseList;
